<template>
  <VRow
    v-if="isVisible"
    justify="center"
  >
    <VCol
      cols="12"
      class="px-2 pt-2 d-flex justify-center"
    >
      <div :id="containerId" />
    </VCol>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'STurnstileManaged',
};
</script>

<script setup lang="ts">
import { computed, onBeforeUnmount } from 'vue';
import {
  TURNSTILE_MANAGED_CONTAINER_ID,
  hasManagedTurnstileKey,
  isManagedCaptchaRequired,
  unmountManagedTurnstile,
} from '../../utils/turnstile';

const containerId = TURNSTILE_MANAGED_CONTAINER_ID;
const isVisible = computed(() => hasManagedTurnstileKey() && isManagedCaptchaRequired.value);

onBeforeUnmount(() => {
  unmountManagedTurnstile();
});
</script>
